import authRoutes from '../Auth/routes';
import contentRoutes from '../Content/routes';
import buyRoutes from '../Buy/routes';
import cookbookRoutes from '../Cookbook/routes';
import knowledgeRoutes from '../Knowledge/routes';
import achievementsRoutes from '../Achievements/routes';
import hydrationRoutes from '../Hydration/routes';
import removeAccountRoutes from '../RemoveAccount/routes';
import goalSettingsRoutes from '../GoalSettings/routes';
import measurementsRoutes from '../Measurements/routes';
import biometricSettingsRoutes from '../BiometricSettings/routes';
import trackerSettingsRoutes from '../TrackerSettings/routes';
import nutritionSettingsRoutes from '../NutritionSettings/routes';
import allSettingsRoutes from '../AllSettings/routes';

import { Route } from './types';

const allRoutes: Route[] = [
  ...authRoutes,
  ...contentRoutes,
  ...buyRoutes,
  ...cookbookRoutes,
  ...knowledgeRoutes,
  ...achievementsRoutes,
  ...hydrationRoutes,
  ...removeAccountRoutes,
  ...goalSettingsRoutes,
  ...measurementsRoutes,
  ...biometricSettingsRoutes,
  ...trackerSettingsRoutes,
  ...nutritionSettingsRoutes,
  ...allSettingsRoutes,
];

export default allRoutes;
